module.exports = __webpack_public_path__ + "static/WS_appflows_fisica_4-39f4c2fa538a86f1c55cc3852b573fcb.gif";